
module.exports = (function(){
  var d = _eai_d;
  var r = _eai_r;
  window.emberAutoImportDynamic = function(specifier) {
    if (arguments.length === 1) {
      return r('_eai_dyn_' + specifier);
    } else {
      return r('_eai_dynt_' + specifier)(Array.prototype.slice.call(arguments, 1))
    }
  };
  window.emberAutoImportSync = function(specifier) {
    return r('_eai_sync_' + specifier)(Array.prototype.slice.call(arguments, 1))
  };
  function esc(m) {
    return m && m.__esModule ? m : Object.assign({ default: m }, m);
  }
    d('@formatjs/intl', EAI_DISCOVERED_EXTERNALS('@formatjs/intl'), function() { return esc(require('@formatjs/intl')); });
    d('@fortawesome/fontawesome-svg-core', EAI_DISCOVERED_EXTERNALS('@fortawesome/fontawesome-svg-core'), function() { return esc(require('@fortawesome/fontawesome-svg-core')); });
    d('@whoicd/icd11ect', EAI_DISCOVERED_EXTERNALS('@whoicd/icd11ect'), function() { return esc(require('@whoicd/icd11ect')); });
    d('@whoicd/icd11ect/style.css', EAI_DISCOVERED_EXTERNALS('@whoicd/icd11ect/style.css'), function() { return esc(require('@whoicd/icd11ect/style.css')); });
    d('moment', EAI_DISCOVERED_EXTERNALS('moment'), function() { return esc(require('moment')); });
    d('moment-timezone', EAI_DISCOVERED_EXTERNALS('moment-timezone'), function() { return esc(require('moment-timezone')); });
    d('numeral', EAI_DISCOVERED_EXTERNALS('numeral'), function() { return esc(require('numeral')); });
    d('qunit', EAI_DISCOVERED_EXTERNALS('qunit'), function() { return esc(require('qunit')); });
    d('slim-select', EAI_DISCOVERED_EXTERNALS('slim-select'), function() { return esc(require('slim-select')); });
    d('tracked-built-ins', EAI_DISCOVERED_EXTERNALS('tracked-built-ins'), function() { return esc(require('tracked-built-ins')); });
    d('_eai_dyn_laravel-echo', [], function() { return import('laravel-echo'); });
    d('_eai_dyn_pusher-js', [], function() { return import('pusher-js'); });
})();
